import React, { useLayoutEffect, useState } from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../styles/theme/aistheme.css";
import "../../styles/theme/sharedThemeOverride.css";

import { ContentDisplayRX, landingContentPresenter$ } from "../../globals/observables/landing/landingContentObservable";
import { MenuItemType } from "../../globals/data/menuData/menuData";
import ExamplePresenter2 from "./example2/example2Presenter";
import ExamplePresenter1 from "./example1/example1Presenter";
import StaffCreatorPresenter from "./staffCreator/staffCreatorPreenter";
import AliPagePresenter from "./aliPage/aliPagePresenter";
import AliSubPagePresenter from "./aliPage/aliSubPage";




const GeneralButtonStyle = {
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  color: "black",
  height: "35px",
  marginTop: "auto",
  marginBottom: "auto",
  width: "35px",
  backgroundColor: "gray",
  maxHeight: "35px !Important",
  maxWidth: "35px  !Important",
  minHeight: "35px !Important",
  minWidth: "35px  !Important",
  padding: "0px"
};


const WrapperContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    background-color: pink;

    flex-bassis:100%;
 
         
    
    `
);



const DisplayLabelContainer = styled("div")(
  ({ theme }) => `
    color: #FFFFFF;
    
    margin-top: 0px;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
  
    font-family: 'poppins';
    font-weight: 400;
    font-size: calc(16px + (20 - 16) * ((100vw - 1366px) / (2560 - 1366)));
  
  
    `
);



interface HeaderProps {

}


function PagesPresenter(props: HeaderProps) {



  const [currentContent, setCurrentContent] = useState<ContentDisplayRX>({} as ContentDisplayRX);

  useLayoutEffect(() => {
    const LandingContentPresenter$ = landingContentPresenter$.subscribe(setCurrentContent);


    return () => {
      LandingContentPresenter$.unsubscribe();
    };
  }, [])


  return (
    <WrapperContainer id="mennu block WrapperContainer">

      {
        (currentContent !== undefined && currentContent.menuItemType !== MenuItemType.NONE)
          ?
          (currentContent.menuItemType === MenuItemType.STAFF_CREATOR)
            ?
            <StaffCreatorPresenter />
            : (currentContent.menuItemType === MenuItemType.EXAMPLE_ITEM_1)
              ?
              <ExamplePresenter1 />
              : (currentContent.menuItemType === MenuItemType.ALI_PAGE)
                ?
                <AliPagePresenter />
                : (currentContent.menuItemType === MenuItemType.ALI_SUB_PAGE)
                  ?
                  <AliSubPagePresenter />
                  : (currentContent.menuItemType === MenuItemType.EXAMPLE_ITEM_2)
                  && <ExamplePresenter2 />
          :
          <>Loading</>
      }

    </WrapperContainer>

  )
}


export default PagesPresenter;